import { useState, useEffect } from "react";

export const useCurrentQuantity = (requests, id) => {
    const [currentQuantity, setCurrentQuantity] = useState(0);

    useEffect(() => {
        if (!requests) return currentQuantity;
        if (requests.find(item => item.id === id)) {
            setCurrentQuantity(requests.find(item => item.id === id).qty);
        } else {
            return currentQuantity;
        }
    }, [currentQuantity, requests, id]);

    return { currentQuantity, setCurrentQuantity };

}
